import { offlineDemoStorageKey } from 'src/features/offline-demo/boot';

export const DEVICE_SYNC_STORAGE_KEY = offlineDemoStorageKey('pointcraft-device-sync-v4');
